export const expandedDrawerWidth = 280;
export const collapsedDrawerWidth = 64;
export const consoleBlue = "#1a73e8";
export const consoleSidebarBg = "#f8fafd";
export const consoleSelectedBg = "#e8f0fe";
export const consoleBorder = "#dadce0";
export const appBarHeight = "var(--app-bar-height, 76px)";

